export default "__VITE_PUBLIC_ASSET__474eb5bc__"